import { api } from "../App";
import { GET_CLASS_PARALLEL_LIST, GET_DAILY_ROUTINE_LIST, GET_DAYS_LIST } from "./types";
import { createNotification } from "../components/Notifications/Notifications";

export const getClassParallelList = () => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/xp_periods`);
    dispatch({ type: GET_CLASS_PARALLEL_LIST, payload: data });
  } catch (error) {
    console.error('Error in dailyRoutine action:', error);
  }
};

export const createCopyDailyRoutine = (xp_key) => async (dispatch, getState) => {
  try {
    await api.post(`/xp_periods_copy/${xp_key}`);
    createNotification('success', 'Успешно');
    await dispatch(getClassParallelList());
  } catch (error) {
    console.error('Error in dailyRoutine action:', error);
    createNotification('error', "Не удалось создать запись");
  }
};

export const deleteDailyRoutine = (xp_key) => async (dispatch, getState) => {
  try {
    // вначале удалить параллели, а затем сам распорядок
    await api.delete(`/xp_periods/parallels/${xp_key}`);
    await api.delete(`/xp_periods/${xp_key}`);
    await dispatch(getClassParallelList());
    createNotification('success', 'Успешно');
  } catch (error) {
    console.error('Error in dailyRoutine action:', error);
    createNotification('error', error.message || "Произошла ошибка");
  }
};

//ДНИ ДЛЯ 1-Й ВКЛАДКИ В МОДАЛКЕ НА ВЫБРАННЫЙ РАСПОРЯДОК

// export const getDays = (xp_key) => async (dispatch, getState) => {
//   await dispatch(checkAndUpdateToken());
//   if (getState().auth.token) {
//     const response = await fetch(`${API_BASE_URL}/xp_periods_days/${xp_key}`, {
//       method: "GET",
//       ...buildDefaultHeaders(getState),
//     });
//     if (response.ok) {
//       const data = await response.json();
//       dispatch({ type: GET_DAYS_LIST, payload: data });
//     }
//   }
// };
export const createDailyRoutine = ({ xp_key, parallels, week_days: day, ...data }) => async (dispatch, getState) => {
  try {
    const { data: result } = await api.post(`/xp_periods`, data);
    await api.post(`/xp_periods_days/${result.xp_key}`, { days: day });
    await api.post(`/xp_periods/parallels/${result.xp_key}`, parallels);
    createNotification('success', 'Успешно');
    await dispatch(getClassParallelList());
  } catch (error) {
    console.error('Error in dailyRoutine action:', error);
    createNotification('error', "Не удалось создать запись");
  }
};
export const updateDailyRoutine = ({ xp_key, parallels, week_days: day, ...data }) => async (dispatch, getState) => {
  try {
await api.put(`/xp_periods/${xp_key}`, data);
      await api.put(`/xp_periods_days/${xp_key}`, { days: day });
      await api.put(`/xp_periods/parallels/${xp_key}`, parallels);
      createNotification('success', 'Успешно');
      await dispatch(getClassParallelList());
  } catch (error) {
    console.error('Error in dailyRoutine action:', error);
    createNotification('error', "Не удалось создать запись");
  }
};
////////////////ДНИ ДЛЯ 1-Й ВКЛАДКИ В МОДАЛКЕ НА ВЫБРАННЫЙ РАСПОРЯДОК



//СОСТАВ вторая вкладка
export const getDailyRoutineList = (xp_key) => async (dispatch, getState) => {
  try {
const { data } = await api.get(`/xp_periods_daily/${xp_key}`);
      dispatch({ type: GET_DAILY_ROUTINE_LIST, payload: data });
  } catch (error) {
    console.error('Error in dailyRoutine action:', error);
  }
};

//СОСТАВ вторая вкладка в МОДАЛке предусмотрена возможность сохранять много обьектов
export const createDailyRoutineConsists = ({ xp_key, ...data }) => async (dispatch, getState) => {
  try {
await api.post(`/xp_periods_daily/${xp_key}`, [data]);
      createNotification('success', 'Успешно');
      await dispatch(getDailyRoutineList(xp_key));
  } catch (error) {
    console.error('Error in dailyRoutine action:', error);
    createNotification('error', "Не удалось создать запись");
  }
};


export const updateDailyRoutineConsists = ({ xp_key, xp_period, ...data }) => async (dispatch, getState) => {
  // xp_key == выбранное мероприятие внутри СОСТАВА
  // xp_period == выбранный распорядок верх
  try {
await api.put(`/xp_periods_daily/${xp_key}`, data);
      createNotification('success', 'Успешно');
      await dispatch(getDailyRoutineList(xp_period));
  } catch (error) {
    console.error('Error in dailyRoutine action:', error);
    createNotification('error', "Не удалось создать запись");
  }
};

export const deleteDailyRoutineConsists = ({ xp_key, xp_period, ...data }) => async (dispatch, getState) => {
  // xp_key == выбранное мероприятие внутри СОСТАВА
  // xp_period == выбранный распорядок верх
  try {
await api.delete(`/xp_periods_daily/${xp_key}`);
      await dispatch(getDailyRoutineList(xp_period));
      createNotification('success', 'Успешно');
  } catch (error) {
    console.error('Error in dailyRoutine action:', error);
    createNotification('error', "Не удалось создать запись");
  }
};
//СОСТАВ вторая вкладка в МОДАЛке предусмотрена возможность сохранять много обьектов

